import React from 'react';
import { cn } from '../lib/utils';

export interface StatPillProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  value: string | number;
  /** Highlight the pill as the currently-applied filter (only meaningful when clickable). */
  active?: boolean;
}

function StatPill({ label, value, className, active, onClick, ...props }: StatPillProps) {
  const interactive = typeof onClick === 'function';
  return (
    <div
      className={cn(
        'inline-flex max-w-full min-w-0 items-center gap-2 rounded-lg border bg-white px-3 py-1.5 shadow-sm',
        interactive && active ? 'border-statura-ink ring-1 ring-statura-ink' : 'border-slate-200',
        interactive &&
          'cursor-pointer transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-statura-ink',
        className,
      )}
      onClick={onClick}
      {...(interactive
        ? {
            role: 'button',
            tabIndex: 0,
            'aria-pressed': active ?? false,
            onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.currentTarget.click();
              }
            },
          }
        : {})}
      {...props}
    >
      <span className="min-w-0 break-words font-body text-eyebrow uppercase text-slate-600 [overflow-wrap:anywhere]">
        {label}
      </span>
      <span className="shrink-0 font-body text-body-sm font-bold text-statura-ink tabular-nums">
        {value}
      </span>
    </div>
  );
}

export { StatPill };
